import React, { Component } from 'react';
import Helmet from 'react-helmet';
import qs from 'query-string';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

import { TransitionWrapper } from '../components/TransitionWrapper';
import breakpoints from '../styles/breakpoints';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import { Section, Title, WideContent } from '../components/Article';
import CarInformation from '../components/CarInformation';
import CarPartsSearchWidget from '../components/widgets/CarPartsSearchWidget';
import StorageNumberSearchWidget from '../components/widgets/StorageNumberSearchWidget';
import CarSelectWidget from '../components/widgets/CarSelectWidget';
import CarPartsSortWidget from '../components/widgets/CarPartsSortWidget';
import PartGroupsWithTypesCheckboxWidget from '../components/widgets/PartGroupsWithTypesCheckboxWidget';
import CarParts from '../components/CarParts';
import partIdQueryHelper from '../utils/partIdQueryHelper';

import { withAppStorage } from '../utils/appStorage';
import { Loader } from '../components/Loader';

import { scrollTo } from '../utils/window';

import CarTypeInfo from '../components/helpers/CarTypeInfo';

const Row = styled.div`
  width: 100%;

  ${breakpoints.large`
		display: flex;
		max-width: ${p => p.theme.globalWidthLarge};
	`};
`;

const Column = styled.div`
  flex: 1;

  ${breakpoints.large`
		margin: 0 ${p => p.theme.gutterSmall};
	`};
`;

const SidebarColumn = styled(Column)`
  flex: 1;
  max-width: 490px;
  margin: 0 auto;
`;

const Sidebar = styled.div`
  border-top: 1px solid ${p => p.theme.colors.border};
  margin-top: 26px;
  padding-top: 20px;
`;

const CarPartsColumn = styled(Column)`
  flex: 2.5;
`;

const Intro = styled.div`
  font-size: 1.5625rem;
  text-align: center;
  margin-top: 200px;
`;

const Description = styled.p`
	text-align: center;
`;

export default withAppStorage(
  class CartPartsPage extends Component {
    componentDidMount() {
      let { location } = this.props;

      if (location.hash === '#sok') {
        scrollTo(document.getElementById('searchelement'), 350);

        document.getElementById('searchelement').focus();
      }
    }

    render() {
      let { location, appStorageTempData } = this.props;

      const query = qs.parse(location.search, { arrayFormat: 'bracket' });

      const regNumber = query.regnr || null;
      const search = query.sok || null;
      const brandId = query.merke ? Number(query.merke) : null;
      const modelId = query.modell ? Number(query.modell) : null;
      const variantId = query.variant ? Number(query.variant) : null;
      const storageNumber = query.lagernummer || null;
      const orderBy = query.orderBy || null;
      // debugger;

      let partTypeIds = query.deletyper || null;
      if (partTypeIds) partTypeIds = partTypeIds.map(Number);

      let partGroupIds = query.delegrupper || null;

      if (partGroupIds) {
        partGroupIds = partIdQueryHelper.filterPartGroupIds(
          partGroupIds,
          partTypeIds
        );
        partGroupIds = partGroupIds.map(Number);

        if (partGroupIds.length === 0) {
          partGroupIds = null;
        }
      }

      let doneLoadingAllPartGroups = true;

      partGroupIds &&
        partGroupIds.forEach(id => {
          if (
            appStorageTempData.partGroupsLoaded &&
            appStorageTempData.partGroupsLoaded.indexOf(id) === -1
          ) {
            doneLoadingAllPartGroups = false;
          }
        });

      let metaTags = {
        title: 'Bildeler',
        description: 'Finn bildeler til bilen din.'
      };

      if (CarTypeInfo[brandId]) {
        metaTags.title = CarTypeInfo[brandId].brand;
        metaTags.description = CarTypeInfo[brandId].header;
      }

      return <TransitionWrapper>
				<Helmet>{GenerateMetaTags(metaTags)}</Helmet>

				<Breadcrumbs breadcrumbs={null} />

				<Section>
					<Title>{metaTags.title}</Title>
					{<Description dangerouslySetInnerHTML={{ __html: CarTypeInfo[brandId] && CarTypeInfo[brandId].body }} /> || null}
					<WideContent>
						<CarInformation regNumber={regNumber} />

						<Row>
							<SidebarColumn>
								<Sidebar>
									<CarPartsSearchWidget />

									<StorageNumberSearchWidget />

									<CarSelectWidget />

									<CarPartsSortWidget />

									<PartGroupsWithTypesCheckboxWidget />
								</Sidebar>
							</SidebarColumn>

							<CarPartsColumn>
								{doneLoadingAllPartGroups && <div>
										{isEmpty(query) ? <Intro>
												Søk blant nesten 6 millioner deler og bestill på nett.
												<br />
												Skriv inn regnummer eller filtrer fra listen til venstre.
											</Intro> : <CarParts regNumber={regNumber} search={search} brandId={brandId} modelId={modelId} variantId={variantId} partGroupIds={partGroupIds} partTypeIds={partTypeIds} storageNumber={storageNumber} orderBy={orderBy} />}
									</div>}
								{!doneLoadingAllPartGroups && <Loader />}
							</CarPartsColumn>
						</Row>
					</WideContent>
				</Section>
			</TransitionWrapper>;
    }
  }
);
